import { useCallback, useState } from 'react';
import { INGREDIENTS } from './data/ingredients.js';
import { applyVote, createTournament } from './lib/tournament.js';
import { startNewSession } from './lib/api.js';
import Home from './components/Home.jsx';
import Showdown from './components/Showdown.jsx';
import Results from './components/Results.jsx';
import MoreInfo from './components/MoreInfo.jsx';

const ALL_IDS = INGREDIENTS.map((i) => i.id);

// Plain path check rather than a router: this is the only secondary page the
// app has. Netlify's SPA redirect (netlify.toml) serves index.html for any
// path, so a direct visit or refresh on /more-info lands here fine. Kept
// outside ShowdownFlow itself so that component's hooks are never conditional.
export default function App() {
  if (window.location.pathname.replace(/\/+$/, '') === '/more-info') {
    return <MoreInfo />;
  }
  return <ShowdownFlow />;
}

function ShowdownFlow() {
  const [tournament, setTournament] = useState(null);
  const [sessionId, setSessionId] = useState(null);

  const handleStart = useCallback(() => {
    setSessionId(startNewSession());
    setTournament(createTournament(ALL_IDS));
  }, []);

  const handleVote = useCallback((pickedId) => {
    setTournament((current) => applyVote(current, pickedId));
  }, []);

  const handlePlayAgain = useCallback(() => {
    setTournament(null);
    setSessionId(null);
  }, []);

  if (!tournament) {
    return <Home onStart={handleStart} />;
  }

  if (!tournament.finished) {
    return <Showdown tournament={tournament} onVote={handleVote} />;
  }

  return <Results sessionId={sessionId} tournament={tournament} onPlayAgain={handlePlayAgain} />;
}
